var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overlay", class: { active: this.$root.menu_active } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "bg" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "1500",
              height: "1000",
              viewBox: "0 0 1500 1000",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink"
            }
          },
          [
            _c("path", {
              style: { fill: _vm.currentBg },
              attrs: {
                opacity: "0.14",
                d:
                  "M-403.924 -414.311L960.144 373.235L-403.924 1160.78L-403.924 -414.311Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                opacity: "0.7",
                d:
                  "M-111.455 65.6893L1252.61 853.235L-111.455 1640.78L-111.455 65.6893Z",
                fill: "#121212"
              }
            }),
            _vm._v(" "),
            _c(
              "mask",
              {
                attrs: {
                  id: "mask0",
                  "mask-type": "alpha",
                  maskUnits: "userSpaceOnUse",
                  x: "-39",
                  y: "108",
                  width: "731",
                  height: "840"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M-38.3525 947.581V108.362L691.503 528.547L-38.3525 947.581Z",
                    fill: "#C4C4C4"
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container text-center" }, [
        _vm.menu
          ? _c("nav", { attrs: { id: "main-nav" } }, [
              _c(
                "ul",
                _vm._l(_vm.menu, function(item) {
                  return _c("li", { key: item.ID }, [
                    _c("a", {
                      staticClass: "bigtext",
                      attrs: { href: item.url },
                      domProps: { textContent: _vm._s(item.title) },
                      on: {
                        mouseover: function($event) {
                          return _vm.changeBg(item.bg)
                        }
                      }
                    })
                  ])
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-trek" }, [
      _c("img", {
        attrs: { src: "/wp-content/themes/dynacap/assets/img/menu-trek.png" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }